import { Router, ActivatedRoute } from '@angular/router';
import { GridApi, GridReadyEvent } from 'ag-grid-community';
import { Component } from '@angular/core';
import { ConnectionService } from '../../../../services/connection-service';
import { AppConfig } from '../../../app.config';
import { WindowRefService } from '../../../../services/window-ref-service';
import moment from 'moment/moment';
import {Models} from "@cureskin/api-client";

@Component({
    selector: 'clinical-report-list', templateUrl: './list.html',
    standalone: false
})
export class ListComponent {
  gridApi: GridApi;
  dataSource: any;
  window: any;
  components: any;
  ui: any = {};
  columnDefs: any;
  count: number;

  searchKey: string;
  constructor(private router: Router,
    private conn: ConnectionService,
    public appConfig: AppConfig,
    windowRef: WindowRefService,
    private route: ActivatedRoute) {
    this.window = windowRef.nativeWindow;
  }

  ngOnInit(): void {
    this.listViewSetup();
    this.route.queryParams.subscribe((params: any) => {
      this.reset();
    });
  }

  listViewSetup(): any {
    this.ui = { grid: { rowModelType: 'infinite', pageSize: 100 } };
    this.setUpGrid();
  }

  setUpGrid(): void {
    this.dataSource = {
      rowCount: null,
      getRows: (params: any): void => {
        this.loadMore(params)
          .then((data: Array<any>) => {
            if (params.startRow === 0 && !data.length) this.gridApi.showNoRowsOverlay();
            else this.gridApi.hideOverlay();
            params.successCallback(data, data.length === this.ui.grid.pageSize ? -1 : params.startRow + data.length);
          });
      },
    };
    this.components = {
      loadingRenderer(params: any): any {
        if (params.value) return params.value;
        return '';
      },
    };
    this.columnDefs = [
      {
        headerName: 'Edit',
        width: 50,
        cellRenderer: (params: any): any => {
          if (!params.data) return '';
          const id = params.data.objectId;
          const eDiv = this.window.document.createElement('div');
          eDiv.innerHTML = `<a class='fa fa-pencil-square-o' href='/products/clinicalReport/${id}/edit'></a>`;
          return eDiv;
        },
      },
      {
        headerName: 'mainConcern',
        field: 'mainConcern',
        pinned: 'left',
        cellRenderer: (params: any): any => {
          if (!params.data) {
            const eDiv = this.window.document.createElement('div');
            eDiv.innerHTML = 'Loading ...';
            return eDiv;
          }
          const eDiv = this.window.document.createElement('div');
          eDiv.innerHTML = params.value ?? '-';
          return eDiv;
        },
        width: 250,
      },
      {
        headerName: 'usedFor',
        width: 100,
        field: 'usedFor',
      },
      {
        headerName: 'active',
        width: 80,
        field: 'active',
      },
      {
        headerName: 'updatedAt',
        width: 150,
        field: 'updatedAt',
        cellRenderer: (params: any): any => {
          if (!params.value) return '';
          const eDiv = this.window.document.createElement('div');
          eDiv.innerHTML = moment(params.value).format('DD MMM YY, HH:mm A') ?? '-';
          return eDiv;
        },
      },
    ];
    this.columnDefs.forEach((e: any) => {
      const each = e;
      each.sortable = true;
    });
  }

  reset(): void {
    if (!this.gridApi) return;
    this.gridApi.setGridOption('datasource', this.dataSource);
  }

  resetFilters(): void {
    delete this.searchKey;
    this.reset();
  }

  onGridReady(params: GridReadyEvent): void {
    this.gridApi = params.api;
    this.gridApi.setGridOption('defaultColDef', { width: 120 });
    this.gridApi.setGridOption('columnDefs', this.columnDefs);
    this.gridApi.setGridOption('cacheBlockSize', this.ui.grid.pageSize);
    this.gridApi.setGridOption('animateRows', true);
    this.gridApi.setGridOption('datasource', this.dataSource);
    this.reset();
  }

  async loadMore(params: any): Promise<any> {
    let data: Array<Models.ClinicalReport>;
    if (this.searchKey) {
      const response = await this.conn.findClinicalReportByMainConcern(this.searchKey);
      data = [response.clinicalReport];
    } else {
      const response = await this.conn.fetchClinicalReportsList(params.startRow, this.ui.grid.pageSize);
      data = response.clinicalReports || [];
    }
    this.count = data.length;
    return data;
  }
}
